export const addWebpExt = (imageUrl: string): string => {
  if (!imageUrl.includes('.webp') && imageUrl.match(/(.png|.jpg|.jpeg)/)) {
    return `${imageUrl}.webp`;
  }

  return imageUrl;
};
